import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { LuTriangleAlert, LuInfo } from "react-icons/lu";
import { match, useAppkitConfig } from ".";
/** A styled container for different purposes */
export const Card = ({ kind, iconPos = "left", children, ...rest }) => {
    const config = useAppkitConfig();
    return (_jsxs("div", { css: {
            display: "inline-flex",
            flexDirection: iconPos === "left" ? "row" : "column",
            borderRadius: 4,
            padding: "8px 16px",
            gap: 16,
            alignItems: "center",
            "& > svg": {
                fontSize: 24,
                minWidth: 24,
            },
            ...match(kind, {
                "error": () => ({
                    backgroundColor: config.colors.danger0,
                    border: `1.5px solid ${config.colors.danger0}`,
                    color: config.colors.danger0BwInverted,
                }),
                "info": () => ({
                    backgroundColor: config.colors.neutral10,
                }),
            }),
        }, ...rest, children: [match(kind, {
                "error": () => _jsx(LuTriangleAlert, {}),
                "info": () => _jsx(LuInfo, { css: { color: config.colors.neutral60 } }),
            }), _jsx("div", { children: children })] }));
};
//# sourceMappingURL=card.js.map